<template>
  <v-app>
    <Navigation></Navigation>
    <router-view class="container" />
  </v-app>
</template>

<script>
import {
  db,
  usersCollection,
  currentCollection,
  gamesCollection
} from "@/main";
import firebase from "@/main.js";
import Navigation from "./components/Navigation.vue";
export default {
  name: "App",
  components: {
    Navigation
  },
  data: () => ({
    do_unsubscribe: null,
    do_playersList: null,
    do_allResults: null
  }),
  computed: {
    groupPlay() {
      return this.$store.getters.groupPlay;
    }
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      let unsubscribe;
      if (user) {
         this.$store.dispatch("listeners/startListeners");
              
      } else {
        this.$store.commit("clearAllResults");
      }
    });
  }
};
</script>

<style>
@import './assets/styles/main.css'
</style>
